<template>
  <div class="nova-consulta" :style="'--cor-primaria:' + corPrimaria + '0A; --cor-primaria-02:' + corPrimaria + '2A'">
    <h3 class="nova-consulta-title align">{{funcionalidade.parametros.textos.tituloTelaNovaConsulta}}</h3>
    <el-card v-if="falecomMedico" class="card" shadow="never">
      <h3 class="nova-consulta-title center">Fale com um médico agora</h3>
      <span class="tiny-text">Teleconsulta com clínico geral. Disponível de segunda à sexta, das 08:00 às 18:00</span>
      <div>
        <el-button :style="`background-color: ${corPrimaria}`" class="btn-card margin-btn-1">
          <inline-svg class="svg-btn" :src="require('@/assets/icons/Icon_btn_video.svg')"></inline-svg>
          Médico online
        </el-button>
        <inline-svg class="img-card-right" :fill="`${corPrimaria}4A`" :src="require('@/assets/img/img_consulta_agora.svg')"></inline-svg>
      </div>
    </el-card>
    <div v-if="falecomMedico" style="margin-bottom: 15px">
      <inline-svg width="210"
                  :fill="corPrimaria + '2A'"
                  style="left: 20px;position: relative;margin-right: 25px;"
                  :src="require('@/assets/img/img_zig_zag.svg')"></inline-svg>
      <span>ou</span>
      <inline-svg width="210"
                  :fill="corPrimaria + '2A'"
                  style="position: relative; margin-left:5px"
                  :src="require('@/assets/img/img_zig_zag.svg')">
      </inline-svg>
    </div>
    <el-card v-if="ativaAgendamentoTeleconsulta || ativaAgendamentoPresencial" style="height: 212px;" class="card" shadow="never">
      <h3 class="nova-consulta-title center">Agende uma consulta</h3>
      <span class="tiny-text">Escolha o melhor dia e horário para você.
              As consultas agendadas podem ser presenciais ou por video (teleconsulta).
            </span>
      <div>
        <el-button @click="nextRoutePresencial()"
                   :style="`background-color: ${corBtnPrincipal}`"
                   v-if="ativaAgendamentoPresencial"
                   class="btn-card margin-btn-2">
          <inline-svg height="15" fill="#FFFFFF" class="svg-btn" :src="require('@/assets/icons/Icon_schedule_calendar.svg')"></inline-svg>
          <span class="text-btn-primary">Consulta Presencial</span>
        </el-button>
        <el-button @click="nextRouteVideo()"
                   v-if="ativaAgendamentoTeleconsulta"
                   :style="`background-color: ${corBtnPrincipal}`"
                   class="btn-card">
          <inline-svg height="15" fill="#FFFFFF" class="svg-btn" :src="require('@/assets/icons/Icon_schedule_calendar.svg')"></inline-svg>
         <span class="text-btn-primary">Consulta por Vídeo</span>
        </el-button>
        <inline-svg class="img-card-left" :fill="`${corPrimaria}4A`" height="60" :src="require('@/assets/img/img_consulta_agendar.svg')"></inline-svg>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import inlineSvg from 'vue-inline-svg'
export default {
  components: {
    inlineSvg
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapGetters('SetupApp', ['estilo']),
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    idTermoUsoPresencial () {
      return this.funcionalidade.parametros.idTermoUsoConsultaPresencial
    },
    falecomMedico () {
      return this.funcionalidade.parametros.ativaFaleComMedico
    },
    corBtnPrincipal () {
      return this.estilo.botaoPrincipal.corBotaoPrincipal
    },
    corTextoBtnPrincipal () {
      return this.estilo.botaoPrincipal.corTextoBotaoPrincipal
    },
    ativaAgendamentoPresencial () {
      return this.funcionalidade.parametros.ativaAgendamentoConsultaPresencial
    },
    ativaAgendamentoTeleconsulta () {
      return this.funcionalidade.parametros.ativaAgendamentoTeleconsulta
    },
    ordem () {
      return this.funcionalidade.parametros.ordemLocalEspecialidades
    }
  },
  methods: {
    ...mapActions('Func53', ['setIdAgenda']),
    ...mapActions('BreadCrumbsStore', ['updateIten', 'orderItens']),
    ...mapMutations('BreadCrumbsStore', ['SET_CURRENT_STEP']),
    nextRoutePresencial () {
      const payload = { step: 0, value: 'Consulta Presencial' }
      this.updateIten(payload)
      this.setIdAgenda('1')
      this.$router.push({ path: '/53/TermosDeUso/', query: { id: `${this.idTermoUsoPresencial}` } })
    },
    nextRouteVideo () {
      this.setIdAgenda('2')
      const payload = { step: 0, value: 'Teleconsulta' }
      this.updateIten(payload)
      this.$router.replace({ query: { step: 2 } })
    }
  },
  created () {
    this.SET_CURRENT_STEP(0)
  }
}
</script>
<style lang="less">
#func-53 {
  .card {
    background-color: var(--cor-primaria);
    border: 1px solid;
    border-color: var(--cor-primaria-02);
    border-radius: 10px;
    width: 495px;
    box-shadow: none;
  }
  .svg-btn {
    margin-right: 5px;
    position: relative;
    top: 2px;
  }
  .nova-consulta-title {
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
  }

  .align {
    padding: 30px 0 20px 0px;
  }

  .center {
    text-align: center;
    margin-bottom: 10px;
    margin-top: 5px;
  }
  .nova-consulta {
    padding: 0 20px;
  }
  .tiny-text {
    font-size: 12px;
    line-height: 17px;
    display: block;
    text-align: center;
    color: #333333;
  }

  .btn-card {
    border-radius: 18px;
    color: #FFFFFF;
    padding: 9px 0;
    width: 295px;
  }
  .margin-btn-1 {
    margin-top: 20px;
    margin-bottom: 5px;
    margin-left: 90px;
  }
  .margin-btn-2 {
    margin-top: 20px;
    margin-bottom: 10px;
    margin-left: 90px;
  }
  .img-card-right {
    float: right;
    position: relative;
    top: 9px;
    left: 12px;
  }
  .img-card-left {
    float: left;
    position: relative;
    right: 21px;
    bottom: 3px;
  }
}
</style>
